
import { computed, defineComponent, onMounted, reactive } from 'vue';

export default defineComponent({
  name: 'PagesStampCardList',

  components: {},

  setup(_) {
    // 不確定 ダミー実装

    return {};
  },
});
